import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetDossierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierActivitiesByIdController.php
* @route '/api/dossier/{dossier}/activities'
*/
const GetDossierActivitiesByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierActivitiesByIdController.url(args, options),
    method: 'get',
})

GetDossierActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetDossierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierActivitiesByIdController.php
* @route '/api/dossier/{dossier}/activities'
*/
GetDossierActivitiesByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return GetDossierActivitiesByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetDossierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierActivitiesByIdController.php
* @route '/api/dossier/{dossier}/activities'
*/
GetDossierActivitiesByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDossierActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetDossierActivitiesByIdController::__invoke
* @see app/Http/Controllers/Dossier/GetDossierActivitiesByIdController.php
* @route '/api/dossier/{dossier}/activities'
*/
GetDossierActivitiesByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDossierActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetDossierActivitiesByIdController